
































































































































































import { Vue, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { OrderHistoryDetailLineViewObject, ReceiptLineItemViewObject } from '@/types/apiServerContract';
import ProductTileImage from '@/project/product/product-tile/ProductTileImage.vue';
import authService from '@/core/auth/auth.service';
import detailedPriceFetchService, { PriceDetailedDataExtended } from '@/project/product/services/detailedPriceFetch.service';
import logService from '@/core/logging.service';
import CopyText from '@/project/shared/CopyText.vue';

@Component({
    components: { ProductTileImage, CopyText }
})
export default class OrderLineBlock extends Vue {
    @Prop({
        required: true
    }) model!: OrderHistoryDetailLineViewObject | ReceiptLineItemViewObject;

    @Prop({
        required: true,
        type: Boolean
    }) isFirstBlock!: boolean;

    @Prop({
        required: false,
        type: String,
        validator: value => ['confirmation', 'order-history'].includes(value as string),
        default: 'confirmation'
    }) mode!: 'confirmation' | 'order-history';

    @Prop({
        required: false,
        type: Boolean,
        default: false
    })
    showDiscountColumn!: boolean;

    get isConfirmationPage() {
        return this.mode === 'confirmation';
    }

    get isOrderHistoryPage() {
        return this.mode === 'order-history';
    }

    priceData: PriceDetailedDataExtended | null = null;
    pricesLoaded: boolean = false;

    get productUrl() {
        return this.model.url;
    }

    get hasBidTexts(): boolean {
        if ('bidDescription' in this.model && 'bidNumber' in this.model) {
            return !!(this.model.bidDescription && this.model.bidNumber);
        }
        return false;
    }

    async getPriceData() {
        if (!this.isUserLoggedIn || this.isOrderHistoryPage) {
            this.pricesLoaded = true;
            return;
        }

        try {
            const request = detailedPriceFetchService.requestData(this.model.itemId);
            const result = await request.promise;
            this.priceData = Object.freeze(result);
        } catch (error) {
            logService.error(error);
        } finally {
            if (!this.isERPServiceAvailable) {
                this.$emit('priceNotAvailable');
            }
            this.pricesLoaded = true;
        }
    }

    get isERPServiceAvailable(): boolean {
        return (this.isOrderHistoryPage || this.priceData?.isServiceAvailable) ?? false;
    }

    get isUserLoggedIn(): boolean {
        return authService.isLoggedIn();
    }

    formatDutyDescription(dutyText) {
        return `(${dutyText.toLowerCase()})`;
    }

    created() {
        this.getPriceData();
    }
}
